import { isPresent } from '@ember/utils';

export function paymentDeclinedDetail(error): string | undefined {
  if (isPresent(error?.errors) && error.errors[0].status === '402') {
    return error.errors[0].detail;
  }

  return undefined;
}

export function isAlreadyConnectedError(error): boolean {
  if (isPresent(error.errors)) {
    if (error.errors[0].status === '409') {
      return true;
    }
  }

  return false;
}

export function invalidAttributeDetail(error): string | undefined {
  if (isPresent(error?.errors) && isPresent(error.errors[0]?.source?.pointer)) {
    return error.errors[0].detail;
  }

  return undefined;
}

interface IApiError {
  detail?: string;
  source?: { pointer?: string };
}

export function apiErrorMessages(error: unknown): string[] {
  const errors = (error as { errors?: IApiError[] } | undefined)?.errors;

  if (!Array.isArray(errors)) {
    return [];
  }

  return errors.flatMap((item) =>
    item.source?.pointer && item.detail ? [item.detail] : [],
  );
}
